import { ChevronRight } from 'lucide-react';

import { Badge } from '@Components/ui-v2/badge';
import { TrackedButton } from '@Components/ui-v2/tracked-button';
import { GuidedJourney } from '@Models';
import { accentForIndex } from './journeyCardPalette';
import './JourneyCard.css';

interface JourneyCardProps {
  journey: GuidedJourney;
  index?: number;
  fullWidth?: boolean;
  compact?: boolean;
  onClick?: (journey: GuidedJourney) => void;
}

const JourneyCard = ({ journey, index = 0, fullWidth = false, compact = false, onClick }: JourneyCardProps) => {
  const accent = accentForIndex(index);

  return (
    <div
      className={`agent-journey-card animate-journey-slide-up${compact ? '' : ' h-full'}${
        fullWidth ? ' sm:col-span-2' : ''
      }`}
      style={{ animationDelay: `${index * 0.1 + 0.08}s`, ['--agent-journey-accent' as string]: accent.hex }}>
      <TrackedButton
        type="button"
        variant="ghost"
        buttonName="AGENT_JOURNEY_CARD_CLICK"
        extraLogData={{ journey_id: journey.id, journey_display: journey.display }}
        onClick={() => onClick?.(journey)}
        className={`group relative z-[2] flex h-auto w-full flex-col items-start gap-2 whitespace-normal rounded-[14px] bg-transparent text-left cursor-pointer transition-all duration-150 hover:bg-transparent active:scale-[0.98] ${
          compact ? 'px-3.5 py-3' : 'h-full px-5 py-4'
        }`}>
        <Badge
          variant="outline"
          className="w-fit border-transparent py-0.5 text-[11px] font-bold"
          style={{ backgroundColor: accent.pillBg, color: accent.pillText }}>
          {journey.display}
        </Badge>
        {journey.title && <p className="text-[13px] font-normal leading-snug text-gray-400">{journey.title}</p>}
        {!compact && (
          <ChevronRight
            size={14}
            strokeWidth={1.75}
            aria-hidden
            className="absolute right-3 top-3 text-gray-300 transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-[var(--agent-journey-accent)]"
          />
        )}
      </TrackedButton>
    </div>
  );
};

export default JourneyCard;
